import { memo } from 'react'

import WarningMessage from './WarningMessage'

const WarningMessageComponent = memo(WarningMessage)

export default WarningMessageComponent
